import RequestMapping from '../request-mapping';
import { getRequest } from '../../utils/saga-utils';

function* fetchTranslationsApi(languageCode) {
  const params = { languageCode };
  const url = RequestMapping.fetchTranslations(params);

  return yield getRequest(url);
}

function* fetchUserApi(userId, queryParams = {}) {
  const params = { userId };
  const url = RequestMapping.fetchUser(params);
  return yield getRequest(url, queryParams);
}

export {
  fetchUserApi,
  fetchTranslationsApi,
};
